/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Sleep tool definition: Allows an agent to pause the current response briefly and resume later or when woken.
 */
export type SleepToolDefinition = {
  type: "sleep";
};

/** @internal */
export const SleepToolDefinition$inboundSchema: z.ZodType<
  SleepToolDefinition,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("sleep"),
});
/** @internal */
export type SleepToolDefinition$Outbound = {
  type: "sleep";
};

/** @internal */
export const SleepToolDefinition$outboundSchema: z.ZodType<
  SleepToolDefinition$Outbound,
  z.ZodTypeDef,
  SleepToolDefinition
> = z.object({
  type: z.literal("sleep"),
});

export function sleepToolDefinitionToJSON(
  sleepToolDefinition: SleepToolDefinition,
): string {
  return JSON.stringify(
    SleepToolDefinition$outboundSchema.parse(sleepToolDefinition),
  );
}
export function sleepToolDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<SleepToolDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SleepToolDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SleepToolDefinition' from JSON`,
  );
}
